import { render, staticRenderFns } from "./mailList.vue?vue&type=template&id=34224010&scoped=true&"
import script from "./mailList.vue?vue&type=script&lang=js&"
export * from "./mailList.vue?vue&type=script&lang=js&"
import style0 from "./mailList.vue?vue&type=style&index=0&id=34224010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34224010",
  null
  
)

export default component.exports